"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var RadixPopover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledTrigger = (0, _styledComponents.default)(RadixPopover.Trigger).withConfig({
  displayName: "Trigger__StyledTrigger",
  componentId: "sc-io3kfv-0"
})(["&[data-state='open']{svg{path{fill:", ";}}}"], function (props) {
  return props.activeColor;
});
var Trigger = function Trigger(_ref) {
  var children = _ref.children,
    other = _objectWithoutProperties(_ref, ["children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTrigger, _objectSpread({
    asChild: true
  }, other, {
    children: children
  }));
};
exports.Trigger = Trigger;